import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SearchMethod = 'default' | 'altsearch';

type SearchPreferencesState = {
  searchMethod: SearchMethod;
  setSearchMethod: (method: SearchMethod) => void;
};

export const useSearchPreferencesStore = create(
  persist<SearchPreferencesState>(
    (set) => ({
      searchMethod: 'default',
      setSearchMethod: (method) => set({ searchMethod: method }),
    }),
    {
      name: 'search-preferences-storage', // name of the item in the storage (must be unique)
    }
  )
);